const state = {
  userInfo: {},
  videoIngName: '' // 正在通话中的用户名称
}

const mutations = {
  SET_USER_INFO: (state, data) => {
    state.userInfo = {
      ...state.userInfo,
      ...data
    }
  },
  SET_VIDEOING_NAME: (state, data) => {
    state.videoIngName = data
  },
}

const actions = {
  setUserInfo({ commit }, state) {
    commit('SET_USER_INFO', state)
  },
  setVideoIngName({ commit }, state) {
    commit('SET_VIDEOING_NAME', state)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
